import { FunctionComponent } from 'preact';
import './MastheadOverlay.css';

interface MastheadOverlayProps {
  title?: string;
  subtitle?: string;
}

export const MastheadOverlay: FunctionComponent<MastheadOverlayProps> = ({
  title = 'NOVELIZING',
  subtitle = 'WELCOME',
}) => {
  return (
    <div className="masthead-overlay">
      <div className="masthead-background-text">{title}</div>
      <h1 className="masthead-title">{title}</h1>
      <div className="masthead-subtitle">{subtitle}</div>
    </div>
  );
};
